import { render, staticRenderFns } from "./ReturnReceipt.vue?vue&type=template&id=5b1a6846&scoped=true"
import script from "./ReturnReceipt.vue?vue&type=script&lang=js"
export * from "./ReturnReceipt.vue?vue&type=script&lang=js"
import style0 from "./ReturnReceipt.vue?vue&type=style&index=0&id=5b1a6846&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1a6846",
  null
  
)

export default component.exports